module.exports = __webpack_public_path__ + "img/home-address.b5ed79a1.svg";